export default __webpack_public_path__ + "static/media/bb15.186ab9eb.webp";